<template lang="html">
  <b-container>
    <b-row v-if="env == 'sandbox'">
      <b-col>
        <p class="alert alert-danger">
          Using PayPal sandbox environment!
        </p>
      </b-col>
    </b-row>
    <b-row v-if="!waitingForLicenseSync">
      <b-col lg="6" offset-lg="3">
        <h1 class="mb-3">Soundslides 3 - {{ name[product] }} plan</h1>
        <h2 v-if="plan_id">{{ plan_cost }}</h2>
        <h2 v-if="product.endsWith('_monthly')" class="lead">
          Monthly subscription
        </h2>
        <h2 v-if="!product.endsWith('_monthly')" class="lead">
          Annual subscription
        </h2>

        <b-alert :show="user_doc.subscribed" variant="danger" class="mt-4">
          This payment will upgrade the account associated with
          <strong v-text="user_doc.email" />. If you want to upgrade another
          account, please <b-link size="sm" @click="logout">logout</b-link> of
          this account before proceeding.
        </b-alert>

        <div v-show="plan_id" id="paypal-button-container" class="mt-5" />
        <div v-show="!plan_id">
          No plan found.
        </div>
        <p v-if="env == 'sandbox'" class="small text-muted mt-5">
          Viewable only in sandbox: {{ product }} - {{ plan_id }}
        </p>
        <b-btn v-if="env == 'sandbox'" @click="sendFakeData">Test</b-btn>
      </b-col>
    </b-row>
    <b-row v-if="waitingForLicenseSync">
      <b-col lg="6" offset-lg="3">
        <h1>Syncing data with PayPal ...</h1>
        <div class="d-flex justify-content-center mb-3 mt-5">
          <b-spinner label="Loading..." />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { paypal_env } from "@/defaults";
export default {
  data() {
    return {
      costs: {
        standard: "$19 per year",
        plus: "$39 per year",
        premium: "$69 per year",
        standard_monthly: "$3 per month",
        plus_monthly: "$5 per month",
        premium_monthly: "$10 per month"
      },
      name: {
        standard: "Standard",
        plus: "Plus",
        premium: "Premium",
        standard_monthly: "Standard",
        plus_monthly: "Plus",
        premium_monthly: "Premium"
      },
      products: {
        sandbox: {
          standard: "P-6K646419GB5039525L23RECQ",
          plus: "P-0HU194121D405551AL23REOA",
          premium: "P-0X101438KT394781WL23REYQ",
          standard_monthly: "P-3U880586KC166670ML23RFDI",
          plus_monthly: "P-98P53414F5554345EL23RFMY",
          premium_monthly: "P-8852650112087983VL23RCOI"
        },
        live: {
          standard: "P-4A899307FT590854DL24VCSY",
          plus: "P-8XU43549MN791701GL24VBXI",
          premium: "P-3PB07990UX705864BL24VAZY",
          standard_monthly: "P-4EH14829UR2034901L24VCKQ",
          plus_monthly: "P-6DJ05709XE436533PL24VBNI",
          premium_monthly: "P-70193923B9919463UL24VAJY"
        }
      },
      config: {
        sandbox: {
          client_id:
            "AQWqXb1pW9_leggyC-lEKnYmP_bEq_N-pMgPTQA0iBNlI9N7kNT5ppn_gRVmn1bB0eLsdNTUCilSSJ19"
        },
        live: {
          client_id:
            "AQT1HI4A_jY-uTBXDJ-rh1kzYP4LcceBiCNOoq3OaLlfvPvNyhwMwFo-pMWkRoglQ6MdZkeoW80gl2PB"
        }
      },
      scriptLoaded: false,
      waitingForLicenseSync: false
    };
  },
  computed: {
    env() {
      return paypal_env;
    },
    product() {
      return this.$route.params.plan_id;
    },
    plan_id() {
      return this.products[this.env][this.product];
    },
    plan_cost() {
      return this.costs[this.product];
    },
    user_doc() {
      return this.$store.state.user_doc;
    }
  },
  mounted() {
    //this.loadPayPalScript();
  },
  activated() {
    console.log("activated!");
    if (this.scriptLoaded) {
      this.setLoaded();
    } else {
      this.loadPayPalScript();
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("sign_out");
    },
    loadPayPalScript() {
      console.log("loadPayPalScript");
      const script = document.createElement("script");
      const client_id = this.config[this.env].client_id;
      script.src = `https://www.paypal.com/sdk/js?client-id=${client_id}&vault=true&disable-funding=credit`;
      script.addEventListener("load", this.setLoaded);
      document.body.appendChild(script);
    },
    sendFakeData() {
      var _v = this;
      var data = {
        billingToken: "BA-134926900V045300H",
        facilitatorAccessToken:
          "A21AAFJrBVIhbj8GGNIwC-_nDnF5zRw-Us1Cy8z0M_HsbJDw0-6ZKaqeLtYR5YaWqv-U_WmHfAe86Ctpqdmkstv1occiboTxA",
        orderID: "9PV704487F823303D",
        subscriptionID: "I-B62YJDC1UX8L"
      };
      _v.$store
        .dispatch("billing/savePayPalSubscriptionInfo", data)
        .then(() => {
          console.log("Trigger the subscription check and wait a bit!");
          _v.waitingForLicenseSync = true;
          _v.$store.dispatch("triggerLicenseSync");
          var int = setInterval(function() {
            if (_v.$store.state.user_doc.subscribed) {
              clearInterval(int);
              _v.$router.push({ name: "account" });
            }
          }, 500);
        });
    },
    setLoaded() {
      console.log("setLoaded");
      var _v = this;
      _v.scriptLoaded = true;
      window.paypal
        .Buttons({
          style: {
            shape: "rect",
            color: "blue",
            layout: "vertical",
            label: "pay"
          },
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              plan_id: _v.plan_id
            });
          },
          onApprove: function(data, actions) {
            console.log(actions);
            console.log(data);
            //alert(data.subscriptionID);
            // Save paypal info to user's account.
            _v.$store
              .dispatch("billing/savePayPalSubscriptionInfo", data)
              .then(() => {
                console.log("Trigger the subscription check and wait a bit!");
                _v.waitingForLicenseSync = true;
                _v.$store.dispatch("triggerLicenseSync");
                var int = setInterval(function() {
                  console.log("looking!");
                  if (_v.$store.state.user_doc.subscribed) {
                    clearInterval(int);
                    _v.$router.push({ name: "account" });
                  }
                }, 500);
              });
          }
        })
        .render("#paypal-button-container");
    }
  }
};
</script>

<style lang="css" scoped></style>
